import { gql } from "@apollo/client";

export const GET_CUSTOMER_REPORT_V2 = gql`
  query GetCustomerReportV2(
    $dateRange: CustomerReportDateRangeInput!
    $breakdown: String!
    $metric: String!
    $rollupMode: String!
    $sumMode: String!
    $aggregateAll: Boolean!
    $searchOperator: String
    $searchQuery: String
    $sort: SortInput
    $page: Int
    $perPage: Int
  ) {
    me {
      id
      customerReportV2(
        dateRange: $dateRange
        breakdown: $breakdown
        metric: $metric
        rollupMode: $rollupMode
        sumMode: $sumMode
        aggregateAll: $aggregateAll
        searchOperator: $searchOperator
        searchQuery: $searchQuery
        sort: $sort
        page: $page
        perPage: $perPage
      ) {
        max {
          breakdown
          totalNumCustomers
          metric_0
          metric_30
          metric_60
          metric_90
          metric_120
          metric_150
          metric_180
          metric_210
          metric_240
          metric_270
          metric_300
          metric_330
          metric_360
          metric_390
          metric_420
          metric_450
          metric_480
          metric_510
          metric_540
          metric_570
          metric_600
          metric_630
          metric_660
          metric_690
          metric_720
        }
        min {
          breakdown
          totalNumCustomers
          metric_0
          metric_30
          metric_60
          metric_90
          metric_120
          metric_150
          metric_180
          metric_210
          metric_240
          metric_270
          metric_300
          metric_330
          metric_360
          metric_390
          metric_420
          metric_450
          metric_480
          metric_510
          metric_540
          metric_570
          metric_600
          metric_630
          metric_660
          metric_690
          metric_720
        }
        rows {
          breakdown
          totalNumCustomers
          metric_0
          metric_30
          metric_60
          metric_90
          metric_120
          metric_150
          metric_180
          metric_210
          metric_240
          metric_270
          metric_300
          metric_330
          metric_360
          metric_390
          metric_420
          metric_450
          metric_480
          metric_510
          metric_540
          metric_570
          metric_600
          metric_630
          metric_660
          metric_690
          metric_720
        }
        total
      }
    }
  }
`;

export const EXPORT_CUSTOMER_REPORT_V2 = gql`
  mutation ExportCustomerReportV2(
    $name: String!
    $dateRange: CustomerReportDateRangeInput!
    $breakdown: String!
    $rollupMode: String!
    $sumMode: String!
    $metric: String!
    $searchOperator: String
    $searchQuery: String
  ) {
    exportCustomerReportV2(
      name: $name
      dateRange: $dateRange
      breakdown: $breakdown
      rollupMode: $rollupMode
      sumMode: $sumMode
      metric: $metric
      searchOperator: $searchOperator
      searchQuery: $searchQuery
    ) {
      successMessage
    }
  }
`;
